module.exports = __webpack_public_path__ + "static/media/insuranceLogo-min.bdcac153.png";